export enum DataHubSearchParams {
  TAB = 'tab',
  // sub tab
  MY_REQUESTS_TAB = 'my-requests-tab',
  MY_DATASETS_TAB = 'my-datasets-tab',
}

export enum DataHubTab {
  MY_DATASETS = 'my-datasets',
  MY_REQUESTS = 'my-requests',
  COLLECTION = 'collection',
}

export enum DataHubMyDatasetsTab {
  // ALL = 'All', // remove all tab
  DATASET_MARKETPLACE = 'Data-Marketplace',
  OWN = 'Own',
}

export enum DataHubMyRequestsTab {
  DATASETS = 'datasets',
  DOWNLOAD = 'download',
  DATASET_REQUEST = 'dataset-request',
}
